export enum Section {
  Apps = 'apps',
  AppsSettings = 'apps/settings',
  AppsOverview = 'apps/overview',
  AppsMarketplace = 'apps/marketplace',
  Archives = 'archives',
  Automate = 'automate',
  ChatbotInLivechat = 'chatbot-in-livechat',
  Chats = 'chats',
  Engage = 'engage',
  EngageApiAccess = 'engage/api-access',
  EngageCampaigns = 'engage/campaigns',
  EngageGoals = 'engage/goals',
  EngageTraffic = 'engage/traffic',
  HelpDeskInLivechat = 'helpdesk-in-livechat',
  MoveToText = 'move-to-text',
  HomePage = 'home',
  InstallCode = 'install-code',
  MobileProfile = 'mobile-profile',
  Onboarding = 'onboarding',
  Reports = 'reports',
  Settings = 'settings',
  Subscription = 'subscription',
  Team = 'team',
  Tickets = 'tickets',
  Traffic = 'traffic',
  Welcome = 'welcome',
  AppSignin = 'app-signin',
}
